"use client";

import * as React from "react";
import { motion } from "framer-motion";
import { Calculator } from "lucide-react";
const TOOL_SRC = "https://impiantidentali.co/wp-content/uploads/2026/10/calcolatore-3d-v4.html?embed=1";
export default function CostCalculator() {
  const [h, setH] = React.useState(900);
  React.useEffect(() => {
    function onMsg(e: MessageEvent) {
      const d: any = e.data;
      if (d && d.tool === "id-calc3d" && typeof d.h === "number" && d.h > 300) {
        setH(Math.min(Math.round(d.h), 2800));
      }
    }
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, []);
  return <section id="interactivecostcalculator" data-nav="light" className="relative bg-background text-foreground py-20 md:py-28 px-4 sm:px-6 lg:px-8 border-t border-border">
      <div className="max-w-5xl mx-auto">
        {/* Header Block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="text-center mb-10">
          <div className="inline-flex items-center justify-center gap-2 mb-4 text-xs font-medium uppercase tracking-[0.18em] text-muted-foreground">
            <Calculator className="h-4 w-4" />
            <span>Calcolatore Preventivo Trattamenti</span>
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif tracking-tight text-foreground font-normal">
            Calcola la stima del trattamento
          </h2>

          <p className="mt-4 text-base text-muted-foreground max-w-2xl mx-auto">
            Gira la bocca con il dito, tocca i denti che ti mancano e scegli il
            materiale: la stima si aggiorna con il listino 2026 di SkyDental.
          </p>
        </motion.div>

        {/* Strumento 3D (stesso strumento della pagina dedicata) */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: "easeOut"
      }} className="overflow-hidden rounded-2xl border border-border/80 bg-card shadow-lg shadow-black/[0.03]">
          <iframe src={TOOL_SRC} title="Calcolatore 3D del costo degli impianti dentali" loading="lazy" scrolling="no" className="block w-full" style={{
          height: h + "px",
          border: 0
        }} />
        </motion.div>

        <p className="mt-4 text-center text-sm text-muted-foreground">
          La stima non sostituisce la visita: dopo l&apos;invio della TAC o della
          panoramica ricevi un piano scritto entro 24 ore.
        </p>
      </div>
    </section>;
}